import { NgModule } from '@angular/core';

import { TravellerService } from './traveller.service';

@NgModule({
    imports: [],
    providers: [
        TravellerService,
    ],
})
export class TravellerModule {}